__turbopack_context__.v({
  "checkout2026": "AdyenDropInCheckout-module__hQLx0W__checkout2026",
});
